export async function createRequestEbook(_, payload) {
    const response = await this.$frontendRepositories.requestEbook.create(payload, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return response;
}
  